/**
 * Shared tab navigation for the four main management pages:
 * - Piece Suggestions
 * - Freetext Management
 * - Canonical Pieces
 * - Canonical Composers
 */

import { useNavigate, useLocation } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@brent/core-ui/ui'

export function ManagementTabs() {
  const navigate = useNavigate()
  const location = useLocation()

  // Determine active tab from current route
  const getActiveTab = () => {
    if (location.pathname === '/suggestions') return 'suggestions'
    if (location.pathname === '/freetext') return 'freetext'
    if (location.pathname === '/canonical-pieces') return 'canonical-pieces'
    if (location.pathname === '/canonical-composers') return 'canonical-composers'
    return 'suggestions'
  }

  const handleTabChange = (value: string) => {
    navigate(`/${value}`)
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Repertoire Suggestions</h1>
      </div>
      <Tabs value={getActiveTab()} onValueChange={handleTabChange} className="w-full">
        <TabsList>
          <TabsTrigger value="suggestions">Piece Suggestions</TabsTrigger>
          <TabsTrigger value="freetext">Freetext Management</TabsTrigger>
          <TabsTrigger value="canonical-pieces">Canonical Pieces</TabsTrigger>
          <TabsTrigger value="canonical-composers">Canonical Composers</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
